'use client';

import { useMemo } from 'react';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export interface NativeShareVars {
  title: string;
  text?: string;
  url: string;
}

export async function nativeShare(vars: NativeShareVars): Promise<void> {
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
    throw new Error('Native share is not supported.');
  }
  await navigator.share(vars);
}

export function useNativeShare(): ActionResult<NativeShareVars, void> {
  return useActionHook<NativeShareVars, void>(
    useMemo(
      () => ({ mutationFn: nativeShare }),
      [],
    ),
  );
}
